function Play() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="81"
      height="80"
      viewBox="0 0 81 80"
      fill="none"
      className="play"
    >
      <rect x="0.332031" width="80" height="80" rx="2" fill="white" />
      <path
        d="M50.4258 40L35.2855 48.7412L35.2855 31.2588L50.4258 40Z"
        fill="black"
      />
    </svg>
  );
}

export default Play;
